import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "contactSection"]

  toggle() {
    const selected = this.hasCheckboxTarget && this.checkboxTarget.checked
    if (this.hasContactSectionTarget) {
      this.contactSectionTarget.classList.toggle("hidden", !selected)
    }
  }
}
